var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeechMarks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2396 10.8138C15.3505 12.2211 16.4059 14.204 16.4059 16.7627C16.4059 19.2574 15.6383 21.2404 14.1031 22.7116C12.6319 24.1828 10.7449 24.9184 8.4421 24.9184C6.20326 24.9184 4.31625 24.2148 2.78105 22.8075C1.30981 21.4003 0.574195 19.5772 0.574195 17.3384C0.574195 15.0996 1.27783 12.8927 2.6851 10.7179L9.68945 0.547151H17.5573L13.2396 10.8138ZM30.9903 10.8138C33.1012 12.2211 34.1567 14.204 34.1567 16.7627C34.1567 19.2574 33.3891 21.2404 31.8539 22.7116C30.3827 24.1828 28.4956 24.9184 26.1928 24.9184C23.954 24.9184 22.067 24.2148 20.5318 22.8075C19.0606 21.4003 18.3249 19.5772 18.3249 17.3384C18.3249 15.0996 19.0286 12.8927 20.4358 10.7179L27.4402 0.547151H35.3081L30.9903 10.8138Z",
    fill: "#E4A039"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechMarks);
export default __webpack_public_path__ + "static/media/speech-marks.c69af2b52be332c1738a69d9e9a8ba9a.svg";
export { ForwardRef as ReactComponent };